import { useEffect } from 'react'
import {
  useBeforeUnload,
  useBlocker,
} from 'react-router'

export const Prompt = ({ message, when }) => {
  const blocker = useBlocker(when)

  useBeforeUnload(event => {
    if (!when) {
      return
    }

    event.preventDefault()
    event.returnValue = message
  }, { capture: true })

  useEffect(() => {
    if (blocker.state !== 'blocked') {
      return
    }

    if (window.confirm(message)) {
      blocker.proceed()
    } else {
      blocker.reset()
    }
  }, [blocker, message])

  return null
}
